import { useAutocompleteSource } from '@eas/common-web';
import { ShiftAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useShifts() {
  return useAutocompleteSource<ShiftAutocomplete>({
    url: `${EvidenceApiUrl.SHIFTS}/autocomplete`,
  });
}
